import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

export async function getPlanForDates(householdId, dateStrings){

  const result = {};

  await Promise.all(dateStrings.map(async dateStr => {
    const snap = await getDoc(
      doc(db, "plans", householdId, "days", dateStr)
    );
    if(snap.exists()) result[dateStr] = snap.data();
  }));

  return result;

}

export async function addMealToDay(householdId, dateStr, mealType, mealId){

  const ref = doc(db, "plans", householdId, "days", dateStr);
  const snap = await getDoc(ref);
  const data = snap.exists() ? snap.data() : {};
  const current = data[mealType] || [];

  if(!current.includes(mealId)){
    await setDoc(ref, { ...data, [mealType]: [...current, mealId] });
  }

}

export async function removeMealFromDay(householdId, dateStr, mealType, mealId){

  const ref = doc(db, "plans", householdId, "days", dateStr);
  const snap = await getDoc(ref);
  if(!snap.exists()) return;

  const data = snap.data();
  const updated = (data[mealType] || []).filter(id => id !== mealId);
  await setDoc(ref, { ...data, [mealType]: updated });

}
